import React, { useEffect, useState } from 'react'

import ContractPoliciesContainer from '../../components/ContractPolicies/ContractPoliciesContainer'

const ContractPoliciesPage = () => {
  return (<ContractPoliciesContainer />)
}

export default ContractPoliciesPage